import { ArrowDownDark } from '@icons';
import { UseMutationResult } from '@tanstack/react-query';
import React, { useEffect, useRef } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';

interface UploadButtonProps {
	itemToUpload: {
		key: string;
		label: string;
		description: string;
		mutation: UseMutationResult<any, Error, { file: File }, unknown>;
		progress?: number;
		accepts?: string;
		maxSize?: number;
	};
	setIsTooBig: React.Dispatch<React.SetStateAction<boolean>>;
}

const UploadButton: React.FC<UploadButtonProps> = ({ itemToUpload, setIsTooBig }) => {
	const fileInputRef = useRef<HTMLInputElement | null>(null);
	const handleOnClick = () => {
		fileInputRef.current?.click();
	};
	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0];
		if (file) {
			// if (itemToUpload.accepts) {
			// 	if (!file.name.endsWith(itemToUpload.accepts.split(', ').map((ext) => ext.trim()).join('|'))) {
			// 		alert(`Sono accettati solo file ${itemToUpload.accepts}.`);
			// 		return;
			// 	}
			// }
			const maxSize = itemToUpload.maxSize ?? 5 * 1024 * 1024 * 1024; // 5 GB in byte
			if (file.size > maxSize) {
				setIsTooBig(true);
				event.target.value = ''; // reset input
				return;
			}

			itemToUpload.mutation.mutate({ file });
		}
	};

	useEffect(() => {
		if (itemToUpload.mutation.isSuccess || itemToUpload.mutation.isError) {
			if (fileInputRef.current) {
				fileInputRef.current.value = '';
			}
		}
	}, [itemToUpload.mutation.isSuccess, itemToUpload.mutation.isError]);
	return (
		<>
			<Button
				disabled={itemToUpload.mutation.isPending}
				onClick={handleOnClick}
				className="btn custom-primary-button"
				style={{
					height: '48px',
					fontWeight: 500,
					padding: '12px 24px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					gap: '0.5rem',
					minWidth: '185px',
				}}
			>
				{itemToUpload.mutation.isPending ? (
					<>
						<Spinner animation="border" size="sm" role="status" /> Upload in corso...
						{!!itemToUpload.progress ? <span>{itemToUpload.progress}%</span> : null}
					</>
				) : (
					<>
						<ArrowDownDark
							style={{
								rotate: '180deg',
							}}
						/>
						Carica file
					</>
				)}
			</Button>
			<Form.Control
				type="file"
				{...(itemToUpload.accepts ? { accept: itemToUpload.accepts } : {})}
				ref={fileInputRef}
				onChange={handleFileChange}
				style={{ display: 'none' }}
			/>
		</>
	);
};

export default UploadButton;
